(() => {
  if (window.ysVideoPopupHandlerBound) return;
  window.ysVideoPopupHandlerBound = true;

  function closePopup(popup) {
    popup.querySelectorAll('iframe, video, .video-popup__blackout').forEach((element) => element.remove());
    popup.classList.remove('video-opened');
    const closeButton = popup.querySelector('[data-js-video-popup-close]');
    if (closeButton) closeButton.setAttribute('tabindex', '-1');
  }

  function playPopupMedia(popup) {
    const template = popup.querySelector('template');
    const container = popup.querySelector('[data-js-video-popup-container]');
    if (!template?.content?.firstElementChild || !container || popup.querySelector('video, iframe')) return;

    container.appendChild(template.content.firstElementChild.cloneNode(true));
    const video = popup.querySelector('video');
    if (video) {
      const playback = video.play();
      if (playback?.catch) playback.catch(() => {});
    }

    const youtube = popup.querySelector('.js-youtube');
    if (youtube) youtube.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    const vimeo = popup.querySelector('.js-vimeo');
    if (vimeo) vimeo.contentWindow?.postMessage('{"method":"play"}', '*');
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target) return;

    const closeButton = target.closest('[data-js-video-popup-close]');
    if (closeButton) {
      const popup = closeButton.closest('video-popup');
      if (popup?.classList.contains('video-opened')) {
        event.preventDefault();
        closePopup(popup);
      }
      return;
    }

    const trigger = target.closest('[data-js-video-popup-link]');
    const popup = trigger?.closest('video-popup');
    if (!popup || popup.classList.contains('video-opened')) return;

    event.preventDefault();
    const blackout = document.createElement('div');
    blackout.className = 'video-popup__blackout';
    popup.appendChild(blackout);
    requestAnimationFrame(() => { blackout.style.opacity = '1'; });
    popup.classList.add('video-opened');

    const popupClose = popup.querySelector('[data-js-video-popup-close]');
    if (popupClose) popupClose.setAttribute('tabindex', '0');
    setTimeout(() => playPopupMedia(popup), 50);
  });
})();